import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';

export default async function doAddToPortfolio(
  slug: string,
  purchaseDate: string,
  quantity: number,
  purchasePrice: number
) {
  try {
    await spiritoryWebApi.post('/portfolio', {
      slug,
      purchaseDate,
      quantity,
      purchasePrice,
    });
  } catch (err) {
    throw err;
  }
}
